<template>
  <MainNav v-if="[CLUBS, FUNDS].includes($route.name as string) " />
  <RouterView />
</template>

<script setup lang="ts">
import MainNav from '@/modules/fanvestor/components/MainNav.vue'
import { CLUBS, FUNDS } from '@/modules/fanvestor/routes'
</script>
